import React from "react";
import { api } from "../../../lib/gameApi";
import { ChatRoom } from "./ChatRoom";

export default function DeadChat({ gameId, me }) {
  return (
    <ChatRoom
      gameId={gameId}
      me={me}
      subcollection="deadChat"
      postMessage={api.postDeadChat}
      inputId="dead-chat-input"
      ariaLabel="Dead players chat"
      placeholder="Enter a message"
    />
  );
}
